import { createContext } from "react";
import { ExemptedStudent } from "../types/common";

export const StandAloneExemptedStudentsContext = createContext<{studentList: {name: string, userId: number}[], exemptedStudents: ExemptedStudent[], isCreating?: boolean}>(
  {studentList: [], exemptedStudents: []}
);
